import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";
import { ADMIN_TRAIN } from "@/constants/testIds";

const EMPTY = { title: "", description: "", scheduled_at: "", duration_minutes: 60, track_key: "", link: "" };

export default function AdminSeminars() {
  const [seminars, setSeminars] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const reload = async () => {
    try { const { data } = await api.get("/admin/training/seminars"); setSeminars(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const submit = async () => {
    setBusy(true); setErr("");
    try {
      await api.post("/admin/training/seminars", { ...form, track_key: form.track_key || null });
      setForm(EMPTY); await reload();
    } catch (e) { setErr(apiErrorMessage(e)); }
    finally { setBusy(false); }
  };
  const del = async (id) => {
    if (!window.confirm("Cancel this seminar?")) return;
    await api.delete(`/admin/training/seminars/${id}`);
    await reload();
  };

  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Training admin</div>
        <h1 className="headline-xl">Seminars</h1>
      </header>

      {err && <div className="text-rose-300 text-sm">{err}</div>}

      <div className="glass-panel p-5">
        <div className="eyebrow !text-lifted-text-dim mb-3">Schedule seminar</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <input className="input-lifted md:col-span-2" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <input className="input-lifted" type="datetime-local" value={form.scheduled_at} onChange={(e) => setForm({ ...form, scheduled_at: e.target.value })} />
          <select className="input-lifted" value={form.track_key} onChange={(e) => setForm({ ...form, track_key: e.target.value })}>
            <option value="">All tracks</option>
            <option value="affiliate">Affiliate</option>
            <option value="driver">Driver</option>
            <option value="partner">Partner</option>
            <option value="franchise">Franchise</option>
          </select>
          <input className="input-lifted md:col-span-2" placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          <input className="input-lifted" placeholder="Link (zoom / meet)" value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} />
          <input className="input-lifted" type="number" placeholder="Duration (min)" value={form.duration_minutes} onChange={(e) => setForm({ ...form, duration_minutes: parseInt(e.target.value, 10) || 60 })} />
        </div>
        <button data-testid={ADMIN_TRAIN.seminarCreate} onClick={submit} disabled={busy} className="btn-lifted mt-4 !text-[0.7rem]">
          <Plus className="h-3 w-3" /> {busy ? "Saving…" : "Add seminar"}
        </button>
      </div>

      <div data-testid={ADMIN_TRAIN.seminarsList} className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Title</th>
              <th className="px-4 py-3">Track</th>
              <th className="px-4 py-3">Attendees</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {seminars.map((s) => (
              <tr key={s.id} className="border-b border-white/5">
                <td className="px-4 py-3 text-xs text-lifted-dim whitespace-nowrap">{s.scheduled_at}</td>
                <td className="px-4 py-3 text-lifted-text">{s.title}</td>
                <td className="px-4 py-3"><span className="chip">{s.track_key || "all"}</span></td>
                <td className="px-4 py-3 text-xs text-lifted-dim">{(s.attendees || []).length}</td>
                <td className="px-4 py-3 text-xs uppercase font-bebas tracking-[0.18em]">{s.status}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(s.id)} className="btn-ghost !py-1.5 !px-3 !text-[0.65rem] hover:!text-rose-300"><Trash2 className="h-3 w-3" /></button>
                </td>
              </tr>
            ))}
            {seminars.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-lifted-mute">No seminars scheduled.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
